import { getBMFooterContents } from "@sia/shared/js/contents/layout";

import { scrollToTop, usePathFactory } from "@sia/style-guide";

const contact_form = process.env.REACT_APP_BENCHMARKING_CONTACT_FORM;

export function useFooterContents() {
  const pathFactory = usePathFactory();
  return getBMFooterContents({
    contact: {
      target: () => {
        window.open(pathFactory.create(contact_form), "_blank");
        scrollToTop();
      },
    },
    links: {
      termsAndConditions: {
        target: () => {
          window.open(pathFactory.create("cms/BenchmarkingAGB"), "_blank");
          scrollToTop();
        },
      },
      privacyPolicy: {
        target: () => {
          window.open(pathFactory.create("cms/datenschutzerklaerung"), "_blank");
          scrollToTop();
        },
      },
      help: {
        target: () => {
          window.open(pathFactory.create("cms/benchmarking_faq"), "_blank");
          scrollToTop();
        },
      },
    },
  });
}
